import { css } from 'styled-components'
import { darken } from 'polished'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'
import FacebookSvg from 'resources/svg/icons/facebook-square.svg'
import bgImageDefault from '../images/bg-image.png'

export const heading1 = css`
  font: ${font('default', 'bold', '45px/34px')};
  text-transform: uppercase;
  ${bp('sm')`
    font: ${font('default', 'bold', '24px/1.2')};
  `}
`

export const heading2 = css`
  font: ${font('default', 'medium', '34px/1.2')};
  ${bp('sm')`
    font: ${font('default', 'normal', '24px/1.2')};
  `}
`

export const heading3 = css`
  font: ${font('default', 'bold', '24px/28px')};
  text-transform: uppercase;
`

export const buttonPrimary = css`
  display: inline-block;
  min-height: unset;
  min-width: unset;
  color: ${props => props.theme.palette.general.light};
  font: ${font('default', 'light', '18px/1rem')};
  text-align: center;
  border-radius: 3px;
  text-decoration: none;
  box-sizing: border-box;
  background: ${props => props.theme.palette.primary.alphaDark};
  border: none;
  transition: background 300ms ease, opacity 300ms ease;
  box-shadow: none;
  cursor: pointer;
  user-select: none;
  -webkit-user-drag: none;
  padding: 14px 26px;

  > div {
    padding: 14px 26px;
    white-space: nowrap;
    ${bp('sm')`
      padding: 10px;
    `}
  }

  &:hover,
  &:focus {
    background: ${props => darken(0.1, props.theme.palette.primary.alphaDark)};
    color: ${props => props.theme.palette.general.light};
  }

  &:focus {
    outline: unset;
  }

  &:active {
    background: ${props => props.theme.palette.general.greyDark};
    color: ${props => props.theme.palette.general.light};
  }

  &::-moz-focus-inner {
    padding: 0;
    border: 0;
  }

  &[disabled] {
    background: ${props => props.theme.palette.general.greyDark};
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const container = css`
  width: 85%;
  max-width: 1635px;
  margin: auto;
  padding: 0 40px;
  box-sizing: border-box;
  ${bp('lg')`
    max-width: unset;
    width: 90%;
    padding: 0;
  `}

  ${bp('sm')`
    width: 100%;
    padding: 0 15px;
  `}
`

export const containerWide = css`
  max-width: 1720px;
  margin: auto;
  padding: 0 50px;

  @media (max-width: ${BREAKPOINT.LG}) {
    max-width: 1280px;
  }

  ${bp('lg')`
    max-width: 1120px;
  `}
  ${bp('sm')`
    padding: 0 15px;
  `}
`

export const link = css`
  color: ${props => props.theme.palette.primary.alphaDark};
  transition: all ease-in-out 0.3s;

  &:hover {
    color: ${props => props.theme.palette.primary.beta};
  }

  &:active {
    color: ${props => props.theme.palette.primary.gamma};
  }
`

export const facebookButton = css`
  ${buttonPrimary}
  display: inline-flex;
  align-items: center;
  background-color: ${props => props.theme.palette.general.blueDark};

  &::before {
    content: '';
    margin-right: 10px;
    width: 20px;
    height: 22px;
    background: url(${FacebookSvg}) no-repeat center;
    background-size: 18px;
    filter: invert(100%) sepia(1%) saturate(7494%) hue-rotate(273deg) brightness(103%) contrast(97%);
    display: inline-block;
    margin-left: auto;
  }
`

export const input = css`
  border: 1px solid ${props => props.theme.palette.general.grey};
  border-radius: 2px;
  font: ${font('default', 'bold', '20px/1.5')};
  color: ${props => props.theme.palette.general.strong};
  max-width: 100%;
`

export const label = css`
  display: block;
  color: ${props => props.theme.form.labelColor};
  font: ${font('default', 'normal', '20px/1')};
  margin-bottom: 5px;
`

export const bgImage = css`
  background: url(${bgImageDefault}) no-repeat center;
  background-size: cover;
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(0deg, rgba(32, 31, 30, 1) 0%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 1) 100%);
  }
`
